export default __webpack_public_path__ + "static/media/logo_2.4e12b46f.png";